import React, { FC } from 'react'
import { Box, Media, Text } from '@revolut/ui-kit'
import { ExclamationMark } from '@revolut/icons'

type NotificationProps = {
  message: string
  level: 'warning' | 'error' | 'primary'
} & React.ComponentPropsWithoutRef<typeof Box>

export const Notification: FC<NotificationProps> = ({ message, level, ...rest }) => {
  return (
    <Box bg='grey-100' p='1.5rem' maxWidth='25rem' {...rest} radius='card'>
      <Media>
        <Media.Side mr='.5rem'>
          <ExclamationMark color={level} />
        </Media.Side>
        <Media.Content>
          <Text variant='secondary'>{message}</Text>
        </Media.Content>
      </Media>
    </Box>
  )
}
